export default __webpack_public_path__ + "static/media/not-ok3.7fb09a8a.png";